import {ref, onMounted, watch} from "vue"
import Helper from "@/services/Helper"
import Api from "./services/Api"
import element from "./services/element"
import DTBackend from "@/services/DTBackend"
import UserImage from "./services/UserImage"
import ld from 'lodash'
import {buildData as banInfoBuildData} from "./components/bans_modal/services/bans_modal"
import {
  allCategory,
  approvedCategory,
  newCategory,
  rejectedCategory,
  removedCategory,
} from "@/components/comment_moderation/services/types"
import Notify from "@/services/Notify"
import cfg from "@/services/Config"

export function useCommentModeration(props){
    let categoryList = [
      allCategory,
      newCategory,
      approvedCategory,
      rejectedCategory,
      removedCategory,
    ]
    let hasBeenLoadOnce = ref(false)
    let err = ref("")
    let error = {
      hasError: () => {
        return err.value !== ""
      },
      getError: () => {
        return err.value
      }
    }
    let params = {
      getPostId: () => {
        const postId = props.payload.filter?.post_id

        if (postId === undefined) {
          return null
        }

        if (typeof postId !== 'number') {
          return null
        }

        return postId
      },
      getObjectTypeId: () => {
        return props.payload.filter?.object_type_id ?? null
      },
      isForceShow: () => {
        return props.payload.force_show === true
      },
      getTitle: () => {
        return props.payload.title ?? ""
      },
      getUserIds: () => {
        return props.payload.filter?.user_ids ?? []
      },
      getChannels: () => {
        return props.payload.filter?.channels ?? []
      },
      getQueryString: () => {
        return props.payload.filter?.query_string ?? ""
      },
      getFromDate: () => {
        return props.payload.filter?.from_date ?? ""
      },
      getToDate: () => {
        return props.payload.filter?.to_date ?? ""
      },
      hasTitle: () => {
        return params.getTitle() !== ""
      },
      getLimit: () => {
        let limit = props.payload.limit

        if (limit <= 0 || limit > 100) {
          limit = 15
        }

        return limit
      },
      getCategories: () => {
        const categories = props.payload.categories

        if (categories === undefined) {
          return null
        }

        if (!Helper.inArray(categories, categoryList)) {
          return null
        }

        return categories
      },
      getTypeVisibility: () => {
        let res = props.payload.filter?.type_visibility ?? null

        return res ? parseInt(res) : null
      },
    }
    const comments = {
      loadComponent: ref(true),
      selectAll: ref(false),
      page: ref(1),
      showParent: ref({}),
      showFullText: ref({}),
      edit: ref({}),
      contentRefs: ref({}),
      selectItems: ref({}),
      items: ref([]),
      activeCategory: ref(null),
      loadEmptyItems: ref(false),
      element: {
        getId: (item) => {
          return element.getId(item)
        },
        getUserName: (item) => {
          return element.getUserName(item)
        },
        getUserId: (item) => {
          return element.getUserId(item)
        },
        getText: (item) => {
          return element.getText(item)
        },
        getCreated: (item) => {
          let result, dt, createdAt = element.getCreated(item)

          dt = new DTBackend(createdAt).correctTZGet()
          result = dt.get("%D.%M.%y %H:%I")

          return result
        },
        getAvatar: (item, w, h) => {
          return UserImage.handle(element.getAvatarHost(item), element.getAvatarName(item), w, h)
        },
        hasParent: (item) => {
          return element.getParentId(item) !== 0
        },
        getParentUserName: (item) => {
          return element.getParentUserName(item)
        },
        getParentText: (item) => {
          return element.getParentText(item)
        },
        getParentAvatar: (item, w, h) => {
          return UserImage.handle(element.getParentAvatarHost(item), element.getParentAvatarName(item), w, h)
        },
        getImages: (item, w, h) => {
          let images = []
          let items = element.getImages(item)

          for (let prop in items) {
            let obj = items[prop]
            images.push(
                UserImage.handle(obj["image_host"], obj["image_name"], w, h)
            )
          }

          return images
        },
        hasImages: (item) => {
          return element.getImages(item).length > 0
        },
        getModeratorUserName: (item) => {
          return element.getModeratorUserName(item)
        },
        getModeratorAvatar: (item, w, h) => {
          return UserImage.handle(element.getModeratorAvatarHost(item), element.getModeratorAvatarName(item), w, h)
        },
        getIsModerate: (item) => {
          return element.getIsModerate(item)
        },
        getIsReject: (item) => {
          return element.getReject(item)
        },
        getPublisherLink: (item) => {
          return element.getPublisherLink(item)
        },
      },
      isActiveCategory: (name) => {
        return name === comments.activeCategory.value
      },
      isShowCategory: (name) => {
        return Helper.inArray([name], params.getCategories())
      },
      loadComments: (query, limit, clear) => {
        if (clear === true) {
          comments.clearItems()
          comments.loadEmptyItems.value = false
        }

        comments.loading.loaders.baseLoadStatus.start()

        comments.api.getComments(query, limit).then((items) => {
          if (Helper.isEmptyObject(items)) {
            comments.loadEmptyItems.value = true
          }
          
          comments.items.value.push(...items)
          if (items.length) {
            markLoadOnce()
          }
        }).finally(() => {
          comments.disableLoadComponent()
          comments.loading.loaders.baseLoadStatus.stop()
        })
      },
      clearItems: () => {
        comments.items.value = []
      },
      disableSelectItems: () => {
        comments.items.value.forEach(item => {
          let id = item["id"]

          delete comments.selectItems.value[id]
        });
      },
      toggleAll: () => {
        comments.items.value.forEach(item => {
          let id = item["id"]

          if (comments.selectAll) {
            comments.selectItems.value[id] = true
          } else {
            delete comments.selectItems.value[id]
          }
        });
      },
      toggleAllLabel: () => {
        if (comments.selectAll.value !== undefined) {
          comments.selectAll = comments.selectAll.value
        }

        comments.selectAll = !comments.selectAll
        comments.toggleAll()
      },
      isChecked: (id) => {
        return comments.selectItems.value[id] !== undefined && comments.selectItems.value[id]
      },
      toggleItem: (id) => {
        if (comments.selectItems.value[id] === true) {
          delete comments.selectItems.value[id]
        } else {
          comments.selectItems.value[id] = true
        }
      },
      removeComments: (ids) => {
        comments.items.value = comments.items.value.filter((item) => {
          return !ids.includes(item.id)
        });
      },
      initLoaders: () => {
        comments.loading.statusesProp.forEach((prop)  => {
          let key = `${prop}Status`

          comments.loading.loaders[key] = comments.createLoader(comments.loading[key])
        })
      },
      bindTextarea: (id, el) => {
        comments.contentRefs.value[id] = el
      },
      getTextareaValue: (key) => {
        const textareaElement = comments.contentRefs.value[key];
        if (!textareaElement) {
          throw new Error("Не найден элемент Textarea")
        }

        return textareaElement.value
      },
      createLoader: (statusRef) => ({
        start(id) {
          if (typeof id !== 'undefined') {
            statusRef.value[id] = true
          } else {
            statusRef.value = true
          }
        },
        stop(id) {
          if (typeof id !== 'undefined') {
            statusRef.value[id] = false
          } else {
            statusRef.value = false
          }
        },
        isProcess(id) {
          if (typeof id !== 'undefined') {
            return !!statusRef.value[id]
          } else {
            return !!statusRef.value
          }
        }
      }),
      isLoadComponent: () => {
        return comments.loadComponent.value === true
      },
      disableLoadComponent: () => {
        return comments.loadComponent.value = false
      },
      isShowFullText: (id) => {
        return comments.showFullText.value[id]
      },
      clearShowParent: () => {
        return comments.showParent.value = {}
      },
      isShowParent: (id) => {
        return comments.showParent.value[id]
      },
      isCommentEdit: (id) => {
        return comments.edit.value[id]
      },
      isShowNextPage: () => {
        return comments.loadEmptyItems.value === false && !comments.loading.loaders.baseLoadStatus.isProcess()
      },
      hasItems: () => {
        return Object.keys(comments.items.value).length > 0
      },
      disableSelectAll: () => {
        comments.selectAll = false
      },
      approve: {
        isDisabledBtn: (id) => {
          return comments.loading.loaders.approveLoadStatus.isProcess(id) ||
              !Helper.inArray([comments.activeCategory.value], [newCategory, rejectedCategory])
        },
      },
      reject: {
        isDisabledBtn: (id) => {
          return comments.loading.loaders.rejectLoadStatus.isProcess(id) ||
              !Helper.inArray([comments.activeCategory.value], [newCategory, approvedCategory])
        },
      },
      approveSelect: {
        isDisabledBtn: () => {
          return comments.loading.loaders.approveSelectStatus.isProcess() ||
              Helper.isEmptyObject(comments.selectItems.value) ||
              !Helper.inArray([comments.activeCategory.value], [newCategory, rejectedCategory])
        },
      },
      rejectSelect: {
        isDisabledBtn: () => {
          return comments.loading.loaders.rejectSelectStatus.isProcess() ||
              Helper.isEmptyObject(comments.selectItems.value) ||
              !Helper.inArray([comments.activeCategory.value], [newCategory, approvedCategory])
        },
      },
      api: {
        async getComments(query, limit) {
          return await Api.comments(query, limit)
        },
        async onEdit(id, query) {
          return await Api.edit(id, query)
        },
        async onApprove(query) {
          return await Api.approve(query)
        },
        async onReject(query) {
          return await Api.reject(query)
        },
      },
      events: {
        onCategory: (name) => {
          comments.activeCategory.value = name
          comments.disableSelectAll()
          comments.disableSelectItems()
          comments.clearShowParent()
          comments.page.value = 1

          comments.loadComments({
            "object_id": params.getPostId(),
            "object_type_id": params.getObjectTypeId(),
            "category": comments.activeCategory.value,
            "page": 1,
            "user_ids": params.getUserIds(),
            "min_created": params.getFromDate(),
            "max_created": params.getToDate(),
            "channels": params.getChannels(),
            "query_string": params.getQueryString(),
            "type_visibility": params.getTypeVisibility(),
          }, params.getLimit(), true)
        },
        onShowParent: (id) => {
          let result = !comments.showParent.value[id]

          comments.showParent.value[id] = result
          comments.events.onText(id, result)
        },
        onEdit: (id) => {
          comments.edit.value[id] = !comments.edit.value[id]
        },
        closeEdit: (id) => {
          comments.edit.value[id] = false
        },
        onEditApi: (id) => {
          comments.loading.loaders.saveLoadStatus.start(id)

          comments.api.onEdit(id, {
            "comment_text": comments.getTextareaValue(id)
          }).then(() => {
            Notify.success("Отредактировано")

            comments.events.closeEdit(id)
          }).catch((err) => {
            Notify.error("Ошибка редактирования", err)
          }).finally(() => {
            comments.loading.loaders.saveLoadStatus.stop(id)
          })
        },
        onApproveApi: (id) => {
          comments.loading.loaders.approveLoadStatus.start(id)

          comments.api.onApprove({
            "comment_ids": [id],
          }).then(() => {
            comments.disableSelectAll()
            comments.disableSelectItems()
            comments.removeComments([id])

            Notify.success("Одобрено")
          }).catch((err) => {
            Notify.error("Ошибка одобрения", err)
          }).finally(() => {
            comments.loading.loaders.approveLoadStatus.stop(id)
          })
        },
        onRejectApi: (id) => {
          comments.loading.loaders.rejectLoadStatus.start(id)

          comments.api.onReject({
            "comment_ids": [id],
          }).then(() => {
            comments.disableSelectAll()
            comments.disableSelectItems()
            comments.removeComments([id])

            Notify.success("Отклонено")
          }).catch((err) => {
            Notify.error("Ошибка отклонения", err)
          }).finally(() => {
            comments.loading.loaders.rejectLoadStatus.stop(id)
          })
        },
        onApproveSelect: () => {
          let ids = []
          Object.entries(comments.selectItems.value).forEach(([key]) => {
            ids.push(Number(key))
          })

          if (ids.length <= 0) {
            return
          }

          comments.loading.loaders.approveSelectStatus.start()

          comments.api.onApprove({
            "comment_ids": ids,
          }).then(() => {
            comments.disableSelectAll()
            comments.disableSelectItems()
            comments.removeComments(ids)

            Notify.success("Выбранные комментарии одобрены")
          }).catch((err) => {
            Notify.error("Ошибка одобрения", err)
          }).finally(() => {
            comments.loading.loaders.approveSelectStatus.stop()
          })
        },
        onRejectSelect: () => {
          let ids = []
          Object.entries(comments.selectItems.value).forEach(([key]) => {
            ids.push(Number(key))
          })

          if (ids.length <= 0) {
            return
          }

          comments.loading.loaders.rejectSelectStatus.start()

          comments.api.onReject({
            "comment_ids": ids,
          }).then(() => {
            comments.disableSelectAll()
            comments.disableSelectItems()
            comments.removeComments(ids)

            Notify.success("Выбранные комментарии отклонены")
          }).catch((err) => {
            Notify.error("Ошибка отклонения", err)
          }).finally(() => {
            comments.loading.loaders.rejectSelectStatus.stop()
          })
        },
        onNextPage: () => {
          comments.page.value += 1

          comments.loadComments({
            "object_id": params.getPostId(),
            "object_type_id": params.getObjectTypeId(),
            "category": getActiveCategory(),
            "page": comments.page.value,
            "user_ids": params.getUserIds(),
            "min_created": params.getFromDate(),
            "max_created": params.getToDate(),
            "channels": params.getChannels(),
            "query_string": params.getQueryString(),
            "type_visibility": params.getTypeVisibility(),
          }, params.getLimit(), false)
        },
        onText: (id, force) => {
          if (force !== undefined) {
            comments.showFullText.value[id] = force
          } else {
            comments.showFullText.value[id] = !comments.showFullText.value[id]
          }
        },
        telegramGoSourceLink(item) {
          let link = element.getPublisherLink(item)

          if (!link) {
            Notify.error("Ссылка не найдена!")
            return
          }

          window.open(link, '_blank')
        },
        siteGoSourceLink(item) {
          let commentId = element.getId(item)
          let typeCode = element.getObjectTypeCode(item)
          let postSlug = element.getObjectSlug(item)
          let link = ""

          const urlSite = cfg._("base", "url_site")

          if (typeCode === "sales") {
            link = `${urlSite}/sales/${postSlug}?comment=${commentId}`
          } else if (typeCode === "promocode") {
            let shopSlug = element.getObjectShopSlug(item)
            link = `${urlSite}/shops/${shopSlug}?promocode=${postSlug}&comment=${commentId}`
          } else if (typeCode === "notes") {
            let userId = element.getUserId(item)
            link = `${urlSite}/profile/${userId}?notes=${postSlug}&comment=${commentId}`
          } else if (typeCode === "offers") {
            link = `${urlSite}/offers/${postSlug}&comment=${commentId}`
          } else if (typeCode === "free") {
              link = `${urlSite}/free/${postSlug}&comment=${commentId}`
          } else if (typeCode === "food") {
              link = `${urlSite}/food/${postSlug}&comment=${commentId}`
          } else if (typeCode === "banks") {
              link = `${urlSite}/banks/${postSlug}&comment=${commentId}`
          } else if (typeCode === "games") {
              link = `${urlSite}/games/${postSlug}&comment=${commentId}`
          } else if (typeCode === "giveaways") {
              link = `${urlSite}/giveaways/${postSlug}&comment=${commentId}`
          }

          if (!link) {
            Notify.error("Ссылка не найдена!")
            return
          }

          window.open(link, '_blank')
        }
      },
      loading: {
        baseLoadStatus: ref(false),
        saveLoadStatus: ref({}),
        approveLoadStatus: ref({}),
        rejectLoadStatus: ref({}),
        approveSelectStatus: ref(false),
        rejectSelectStatus: ref(false),
        statusesProp: [
          "baseLoad",
          "saveLoad",
          "approveLoad",
          "rejectLoad",
          "approveSelect",
          "rejectSelect",
        ],
        loaders: {},
      },
    }

    onMounted(() => {
      if (Helper.isEmptyObject(props.payload)) {
        return
      }

      if (checkPayload() === false) {
        return
      }

      init()
    })

    watch(() => props.payload, (newValues, oldValues) => {
      if (checkPayload() === false) {
        return
      }

      comments.activeCategory.value = getActiveCategory()
      comments.page.value = 1

      if (!ld.isEqual(newValues, oldValues)) {
        init()
      }
    })

    function checkPayload() {
      if (params.getCategories() === null) {
        comments.disableLoadComponent()
        setError("Неверный тип категории")

        return false
      }

      return true
    }

    function getActiveCategory() {
      if (comments.activeCategory.value !== null) {
        return comments.activeCategory.value
      }

      let activeCategory = props.payload.active_category ?? null
      if (activeCategory !== null) {
        comments.activeCategory.value = activeCategory
      } else {
        let categories = params.getCategories()

        if (categories === null) {
          comments.activeCategory.value = allCategory
        } else {
          comments.activeCategory.value = categories[0]
        }
      }

      return comments.activeCategory.value
    }

    function init() {
      comments.initLoaders()

      comments.loadComments({
        "object_id": params.getPostId(),
        "object_type_id": params.getObjectTypeId(),
        "category": getActiveCategory(),
        "page": comments.page.value,
        "user_ids": params.getUserIds(),
        "min_created": params.getFromDate(),
        "max_created": params.getToDate(),
        "channels": params.getChannels(),
        "query_string": params.getQueryString(),
        "type_visibility": params.getTypeVisibility(),
      }, params.getLimit(), true)
    }

    function isShowComponent() {
      return (isHasBeenLoadOnce() || (params.isForceShow() && !comments.isLoadComponent())) && !hasError()
    }

    function setError(msg) {
      err.value = msg
    }

    function hasError() {
      return err.value !== ""
    }

    function countCategories() {
      let categories = params.getCategories()
      if (categories === null) {
        return -1
      }

      return params.getCategories().length
    }

    function isHasBeenLoadOnce() {
      return hasBeenLoadOnce.value === true
    }

    function markLoadOnce() {
      return hasBeenLoadOnce.value = true
    }

    return {
      error,
      comments,
      isShowComponent,
      categoryList: {
        allCategory,
        approvedCategory,
        newCategory,
        rejectedCategory,
        removedCategory,
      },
      countCategories,
      params,
      banInfoBuildData,
    }
}
